import { createFileRoute } from '@tanstack/react-router'
import ZaloUserAccount from '@/components/settings-route/multi-channel/zalo-user/zalo-user-account'

export const Route = createFileRoute(
  '/_auth/settings/multi-channels/zalo-user/$tenantId',
)({
  component: RouteComponent,
})

function RouteComponent() {
  const { tenantId } = Route.useParams()

  return <ZaloUserAccount tenantId={tenantId} />
}
